// Compact `{n}/{max}` counters for quiz fields — muted, right-aligned, ported
// from oa-studio-prototype BlockEditor.tsx's `CharCount`/`WordCount` (lines 53–59).
// Deliberately separate from `blocks/design/CharacterCounter` — that one is a
// bordered box built for the design block's settings panel.
import { countWords, wordNoun } from '@/features/editor/lib/quizWordLimits'

interface CharCountProps {
  value?: string | null
  max: number
}

export const CharCount = ({ value, max }: CharCountProps) => {
  const length = (value ?? '').length
  return (
    <p
      className={`text-right text-xs ${length > max ? 'text-destructive' : 'text-muted-foreground'}`}
    >
      {length}/{max}
    </p>
  )
}

interface WordCountProps {
  value?: string | null
  max: number
}

export const WordCount = ({ value, max }: WordCountProps) => (
  <p className="text-right text-xs text-muted-foreground">
    {countWords(value)}/{max} {wordNoun(max)}
  </p>
)
